/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React base styles
import colors from "assets/theme-dark/base/colors";

// Material Dashboard 2 PRO React helper functions
import rgba from "assets/theme-dark/functions/rgba";

const { info, white, gradients } = colors;

const flatpickr = {
  // === Fondo general y color de texto ===
  ".flatpickr-calendar": {
    backgroundColor: "#26304b",
    color: white.main,
    border: "1px solid rgba(255, 255, 255, 0.1)",
    boxShadow: "0 2px 8px rgba(0,0,0,0.4)",
  },

  // === Cabecera (mes/año y navegación) ===
  ".flatpickr-months, .flatpickr-weekdays": {
    backgroundColor: "#26304b",
    color: white.main,
  },

  ".flatpickr-current-month": {
    color: white.main,
    fontWeight: 500,
  },

  ".flatpickr-months .flatpickr-prev-month, .flatpickr-months .flatpickr-next-month": {
    color: white.main,
    fill: white.main,
    transition: "color 0.2s, fill 0.2s",
    padding: "4px",
    borderRadius: "6px",
    "&:hover": {
      backgroundColor: rgba(white.main, 0.08),
      color: `${info.main} !important`,
      fill: `${info.main} !important`,
      cursor: "pointer",
    },
  },

  // === Flechitas del selector de año y mes ===
  ".flatpickr-months .flatpickr-prev-month svg, .flatpickr-months .flatpickr-next-month svg": {
    fill: `${white.main} !important`,
    stroke: `${white.main} !important`,
    width: "14px",
    height: "14px",
    transition: "all 0.2s ease",
  },

  ".flatpickr-months .flatpickr-prev-month:hover svg, .flatpickr-months .flatpickr-next-month:hover svg":
    {
      fill: `${info.main} !important`,
      stroke: `${info.main} !important`,
      cursor: "pointer",
    },

  // === Días ===
  ".flatpickr-day": {
    color: white.main,
    background: "rgba(0, 0, 0, 0)",
  },

  ".flatpickr-day:hover, .flatpickr-day:focus, .flatpickr-day.nextMonthDay:hover, .flatpickr-day.nextMonthDay:focus":
    {
      background: rgba(info.main, 0.25),
      border: "none",
    },

  ".flatpickr-day.today": {
    background: info.main,
    color: white.main,
    border: "none",

    "&:hover, &:focus": {
      background: `${info.focus} !important`,
    },
  },

  ".flatpickr-day.selected, .flatpickr-day.selected:hover, .flatpickr-day.nextMonthDay.selected, .flatpickr-day.nextMonthDay.selected:hover, .flatpickr-day.nextMonthDay.selected:focus":
    {
      background: `${gradients.info.state} !important`,
      color: white.main,
      border: "none",
    },

  // === Semana (Sun, Mon...) ===
  ".flatpickr-weekdays": {
    backgroundColor: "#26304b",
    borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
  },

  ".flatpickr-weekday": {
    color: `${white.main} !important`,
    fontWeight: 500,
    fontSize: "14px",
    textTransform: "uppercase",
  },

  // === Selector de hora ===
  ".flatpickr-time": {
    backgroundColor: "#26304b",
    borderTop: "1px solid rgba(255,255,255,0.1)",
    color: white.main,
  },

  // === Plugin monthSelect (para modo mensual) ===
  ".flatpickr-monthSelect-months": {
    backgroundColor: "#26304b",
    color: white.main,
  },

  ".flatpickr-monthSelect-month": {
    backgroundColor: "#26304b",
    color: white.main,
    borderRadius: "8px",
    padding: "10px",
    margin: "2px",
    transition: "background-color 0.2s",
  },

  ".flatpickr-monthSelect-month:hover": {
    backgroundColor: rgba(info.main, 0.25),
    color: white.main,
    cursor: "pointer",
  },

  ".flatpickr-monthSelect-month.selected": {
    backgroundColor: `${gradients.info.state}`,
    color: white.main,
    fontWeight: 500,
  },

  // === Dropdowns (mes y año) en modo oscuro ===
  ".flatpickr-monthDropdown-months, .flatpickr-monthDropdown-months option, .numInput.cur-year": {
    backgroundColor: "#26304b !important",
    color: `${white.main} !important`,
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: "6px",
    padding: "4px 8px",
    textAlign: "center",
    appearance: "none",
  },

  ".flatpickr-monthDropdown-months:hover, .numInput.cur-year:hover": {
    backgroundColor: rgba(info.main, 0.2),
    color: white.main,
    cursor: "pointer",
  },

  ".flatpickr-monthDropdown-months option:hover, .flatpickr-monthDropdown-months option:focus": {
    backgroundColor: rgba(info.main, 0.3),
    color: white.main,
  },
};

export default flatpickr;
